<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListTabelas";

export default {
  data() {
    return {
      subjectPermission: "TabelasFrete",
    };
  },
  methods: {},
  components: {
    List,
  },
};
</script>
